import { render, staticRenderFns } from "./Declarations.vue?vue&type=template&id=668c3d63&scoped=true"
import script from "./Declarations.vue?vue&type=script&lang=js"
export * from "./Declarations.vue?vue&type=script&lang=js"
import style0 from "./Declarations.vue?vue&type=style&index=0&id=668c3d63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668c3d63",
  null
  
)

export default component.exports